import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20warm%20atmospheric%20reading%20scene%2C%20cozy%20room%20with%20soft%20coral%20and%20golden%20ambient%20lighting%2C%20dreamy%20artistic%20illustration%2C%20warm%20tones%2C%20relaxing%20mood%2C%20elegant%20minimalist%20aesthetic&width=1800&height=700&seq=manhwa-cta-bg&orientation=landscape"
        alt="开始你的韩漫之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 text-center max-w-2xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 mb-4 tracking-wide">
          开启你的韩漫之旅
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-md mx-auto leading-relaxed">
          数千部高清韩漫等你来探索，每日更新，精彩不断
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center -ml-1">
              <i className="ri-play-fill text-background-50 text-xs"></i>
            </div>
            立即阅读
            <i className="ri-arrow-right-up-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer text-sm border border-background-50/20"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}